module.exports = __webpack_public_path__ + "static/img/use.97ef98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/use.png
// module id = 9uHG
// module chunks = 1